// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OrderClientInfo_clientCard__cjRQV {
  background-color: var(--darkGray);
  color: white;
  padding: 5px 25px 10px 25px;
  border-radius: 12px;
  margin-bottom: 25px;
  font-weight: 500;
}

.OrderClientInfo_clientRow__2SXza {
  display: flex;
  flex-wrap: wrap;
  gap: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding: 5px 0;
}

.OrderClientInfo_clientRow__2SXza:last-child {
  border-bottom: none;
}

.OrderClientInfo_clientCol__MiT2t {
  flex: 1 1 25%;
  padding: 0 15px;
  position: relative;
  word-break: break-word;
}

.OrderClientInfo_clientCol__MiT2t:not(:first-child)::before {
  content: "";
  position: absolute;
  left: 0;
  top: 10%;
  height: 80%;
  width: 1px;
  background-color: rgba(255, 255, 255, 0.2);
}

.OrderClientInfo_labelClient__ED-Oy {
  font-weight: 700;
  display: block;
  margin-bottom: 0px;
}

.OrderClientInfo_clientLink__BmeHO {
  color: var(--orange);
  text-decoration: none;
  font-weight: 600;
}

.OrderClientInfo_clientLink__BmeHO:hover {
  text-decoration: underline;
}

@media only screen and (max-width: 768px) {
  .OrderClientInfo_clientRow__2SXza {
    flex-direction: column;
    border-bottom: none;
  }

  .OrderClientInfo_clientCol__MiT2t {
    flex: 1 1 100%;
    padding: 8px 0;
  }

  .OrderClientInfo_clientCol__MiT2t::before {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/styles/OrderClientInfo.module.css"],"names":[],"mappings":"AAAA;EACE,iCAAiC;EACjC,YAAY;EACZ,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,MAAM;EACN,iDAAiD;EACjD,cAAc;AAChB;;AACA;EACE,mBAAmB;AACrB;;AAGA;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,UAAU;EACV,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".clientCard {\n  background-color: var(--darkGray);\n  color: white;\n  padding: 5px 25px 10px 25px;\n  border-radius: 12px;\n  margin-bottom: 25px;\n  font-weight: 500;\n}\n\n.clientRow {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  padding: 5px 0;\n}\n.clientRow:last-child {\n  border-bottom: none;\n}\n\n\n.clientCol {\n  flex: 1 1 25%;\n  padding: 0 15px;\n  position: relative;\n  word-break: break-word;\n}\n\n.clientCol:not(:first-child)::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 10%;\n  height: 80%;\n  width: 1px;\n  background-color: rgba(255, 255, 255, 0.2);\n}\n\n.labelClient {\n  font-weight: 700;\n  display: block;\n  margin-bottom: 0px;\n}\n\n.clientLink {\n  color: var(--orange);\n  text-decoration: none;\n  font-weight: 600;\n}\n\n.clientLink:hover {\n  text-decoration: underline;\n}\n\n@media only screen and (max-width: 768px) {\n  .clientRow {\n    flex-direction: column;\n    border-bottom: none;\n  }\n\n  .clientCol {\n    flex: 1 1 100%;\n    padding: 8px 0;\n  }\n\n  .clientCol::before {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"clientCard": `OrderClientInfo_clientCard__cjRQV`,
	"clientRow": `OrderClientInfo_clientRow__2SXza`,
	"clientCol": `OrderClientInfo_clientCol__MiT2t`,
	"labelClient": `OrderClientInfo_labelClient__ED-Oy`,
	"clientLink": `OrderClientInfo_clientLink__BmeHO`
};
export default ___CSS_LOADER_EXPORT___;
